import { handleActions } from 'redux-actions';
import { types } from './actions';

// INITIAL STATE
const initialState = {
	modal: false,
	loading: {
		users: false,
		search: false
	},
	usuariosAssociados: {},
	usuariosEncontrados: {},
	modalDelete: false
};

// REDUCERS
export default handleActions(
	{
		[types.MODAL_LINK_USER]: (state, action) => ({
			...state,
			modal: action.payload,
			usuariosEncontrados: {}
		}),
		[types.MODAL_DELETE]: (state, action) => ({
			...state,
			modalDelete: action.payload
		}),
		[types.GET_USER.SUCCESS]: (state, action) => ({
			...state,
			usuariosAssociados: action.payload
		}),
		[types.SEARCH_USER.SUCCESS]: (state, action) => ({
			...state,
			usuariosEncontrados: action.payload
		}),
		[types.SEARCH_USER.FAILURE]: (state, action) => ({
			...state,
			usuariosEncontrados: { error: action.payload }
		}),
		[types.REMOVE_USER.SUCCESS]: (state, action) => ({
			...state,
			modalDelete: false
		}),
		[types.LINK_USER.SUCCESS]: (state, action) => ({
			...state,
			modal: false
		}),
		[types.LINK_USER.FAILURE]: (state, action) => ({
			...state,
			usuariosEncontrados: { error: action.payload }
		}),
		[types.LOADING]: (state, action) => ({
			...state,
			loading: { ...state.loading, ...action.payload }
		})
	},
	initialState
);

// SELECTORS

const getSearchUser = state => state.usuarioLink.usuariosEncontrados;

const getModal = state => state.usuarioLink.modal;

const getModalDelete = state => state.usuarioLink.modalDelete;

const getUsersLinked = state => {
	return state.usuarioLink.usuariosAssociados || {};
};

const getListLinked = state => {
	return getUsersLinked(state).content || [];
};

const getCurrentPage = state => {
	return getUsersLinked(state).number || 0;
};

const getTotalServics = state => {
	return getUsersLinked(state).totalElements || 0;
};

const getTotalPaginas = state => {
	return getUsersLinked(state).totalPages || 0;
};

const getLoading = state => state.usuarioLink.loading;

export const selectors = {
	getModal,
	getListLinked,
	getCurrentPage,
	getTotalServics,
	getTotalPaginas,
	getModalDelete,
	getSearchUser,
	getLoading
};
